import { ProfileMenuItem } from "./ProfileMenuItem";
import { 
  User, 
  Package, 
  Heart, 
  // Truck, 
  // CreditCard, 
  Settings,
  HelpCircle,
  Shield,
  LogOutIcon,
  FileText,
  FileWarning,
  Mail
} from "lucide-react";
import { useNavigate } from "react-router";
import { logout } from "@nusrif/services";
import { clearHistoryAndNavigate } from "@nusrif/utils";
export const ProfileMenuSection = () => {
  const navigate = useNavigate();
  const handleLogout = () => {
    logout();
    clearHistoryAndNavigate(navigate, '/');
  };
  const mainMenuItems = [
    {
      icon: User,
      title: "Personal Details",
      onPress: () => navigate('/profile/personal-details')
    },
    {
      icon: Package,
      title: "My Order",
      onPress: () => navigate('/profile/my-orders')
    },
    {
      icon: Heart,
      title: "My Favourites",
      onPress: () => navigate('/profile/my-favourites')
    },
    // {
    //   icon: Truck,
    //   title: "Shipping Address",
    //   onPress: () => navigate('/profile/shipping-address')
    // },
    // {
    //   icon: CreditCard,
    //   title: "My Card",
    //   onPress: () => navigate('/profile/my-cards')
    // },
    {
      icon: Settings,
      title: "Settings",
      onPress: () => navigate('/profile/settings')
    }
  ];
  const supportMenuItems = [
    {
      icon: HelpCircle,
      title: "FAQs",
      onPress: () => navigate('/profile/faqs')
    },
    {
      icon: Shield,
      title: "Privacy Policy",
      onPress: () => navigate('/profile/privacy-policy')
    },
    {
      icon: FileText,
      title: "Terms and Conditions",
      onPress: () => navigate('/profile/terms-and-conditions')
    },
    {
      icon: FileWarning,
      title: "Cancellation and Refund Policy",
      onPress: () => navigate('/profile/cancellation-and-refund-policy')
    },
    {
      icon: Mail,
      title: "Contact Us",
      onPress: () => navigate('/profile/contact-us')
    },
    {
      icon: LogOutIcon,
      title: "Logout",
      onPress: handleLogout
    }
  ];
  return (
    <div className="space-y-6">
      {/* Main Menu Section */}
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm">
        {mainMenuItems.map((item, index) => (
          <ProfileMenuItem
            key={item.title}
            icon={item.icon}
            title={item.title}
            onPress={item.onPress}
            showBorder={index < mainMenuItems.length - 1}
          />
        ))}
      </div>
      {/* Support Menu Section */}
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm">
        {supportMenuItems.map((item, index) => (
          <ProfileMenuItem
            key={item.title}
            icon={item.icon}
            title={item.title}
            onPress={item.onPress}
            showBorder={index < supportMenuItems.length - 1}
          />
        ))}
      </div>
    </div>
  );
};